const sr = {
  pleaseEnterUsername: "Molimo unesite korisničko ime",
  cannotFriendYourself: "Ne možete poslati zahtev za prijateljstvo sami sebi.",
  friendRequestSent: "Zahtev za prijateljstvo je poslat!",
  failedToSendRequest: "Slanje zahteva nije uspelo",
  linkCopied: "Link je kopiran u međuspremnik!",
  backToInvites: "Nazad na pozivnice",
  sendFriendRequestByUsername: "Pošalji zahtev za prijateljstvo pomoću korisničkog imena",
  enterUsername: "Unesite korisničko ime",
  send: "Pošalji",
  yourInviteQrCode: "Vaš QR kod pozivnice",
  inviteLink: "Link pozivnice",
  scanQrOrUseLink: "Skenirajte ovaj QR kod ili koristite ovaj link za slanje zahteva za prijateljstvo",
  copyInviteLink: "Kopiraj link pozivnice",
  goToItem: "Idi na stavku",
  verificationEmailSent: "Verifikacioni imejl je poslat! Proverite prijemno sanduče.",
  verificationEmailFailed: "Slanje verifikacionog imejla nije uspelo. Pokušajte ponovo.",
  verifyYourEmail: "Verifikujte svoju imejl adresu",
  verifyEmailInstructions: "Molimo verifikujte svoju imejl adresu kako biste pristupili svom nalogu. Proverite prijemno sanduče za verifikacioni link.",
  sending: "Slanje...",
  resendVerificationEmail: "Pošalji ponovo verifikacioni imejl",
  login: "Prijava",
  register: "Registracija",
  home: "Početna",
  calendar: "Kalendar",
  friends: "Prijatelji",
  profile: "Profil",
  logout: "Odjava",
  loading: "Učitavanje...",
  language: "Jezik",
  calendarSelectPlaceSuggestion: "Molimo izaberite mesto iz predloga kako bi bile dodate koordinate.",
  calendarSelectDateAndTime: "Molimo izaberite datum i vreme.",
  calendarPositiveDuration: "Molimo unesite pozitivno trajanje.",
  calendarFutureDateRequired: "Datum i vreme događaja moraju biti u budućnosti.",
  calendarCreateEventFailed: "Kreiranje događaja nije uspelo. Pokušajte ponovo.",
  cancel: "Otkaži",
  createNewEvent: "Kreiraj novi događaj",
  week: "Nedelja",
  month: "Mesec",
  eventTitle: "Naslov",
  date: "Datum",
  time: "Vreme",
  duration: "Trajanje",
  endsAt: "Završava se u",
  place: "Mesto",
  searchForPlace: "Pretraži mesto",
  placeSearchTip: "Savet: počnite da kucate i izaberite rezultat da biste dodali koordinate.",
  description: "Opis",
  createEvent: "Kreiraj događaj",
  today: "Danas",
  previousMonth: "Prethodni mesec",
  nextMonth: "Sledeći mesec",
  previous: "Prethodno",
  next: "Sledeće",
  mondayShort: "Pon",
  tuesdayShort: "Uto",
  wednesdayShort: "Sre",
  thursdayShort: "Čet",
  fridayShort: "Pet",
  saturdayShort: "Sub",
  sundayShort: "Ned",
  more: "više",
  mustRespondWillBeforeReposting: "Morate odgovoriti „Prisustvovaću“ pre ponovnog deljenja",
  event: "Događaj",
  backToCalendar: "Nazad na kalendar",
  addToGoogleCalendar: "Dodaj u Google Kalendar",
  when: "Kada",
  where: "Gde",
  openLocationInGoogleMaps: "Otvori lokaciju u Google mapama",
  hosts: "Domaćini",
  yourResponse: "Vaš odgovor",
  currentResponse: "Trenutni odgovor",
  response_will: "Prisustvovaću",
  response_might: "Možda ću prisustvovati",
  response_wont: "Neću prisustvovati",
  willRunIntoYou: "Navratiću",
  mightDropBy: "Možda navratim",
  wontCome: "Neću doći",
  repostToMyFriends: "Podeli ponovo sa prijateljima",
  responses: "Odgovori",
  willAttend: "Prisustvovaće",
  reposted: "Ponovo podeljeno",
  mightAttend: "Možda će prisustvovati",
  cancelEvent: "Otkaži događaj",
  cancellationEmailNoticeBefore: "Osobe koje su potvrdile dolazak",
  cancellationEmailNoticeAfter: "biće obaveštene imejlom o otkazivanju.",
  optionalCancellationMessage: "Opcionalna poruka učesnicima (maksimalno 1000 karaktera)",
  confirmCancelEvent: "Potvrdi otkazivanje događaja",
  clear: "Obriši",
  confirmCancellation: "Potvrdi otkazivanje",
  confirmCancellationMessage: "Da li ste sigurni da želite da otkažete ovaj događaj? Potvrđeni učesnici će biti obavešteni, a događaj uklonjen.",
  eventCancelledNotified: "Događaj je otkazan. Obavešteni:",
  attendees: "učesnici",
  failedToCancelEvent: "Otkazivanje događaja nije uspelo",
  back: "Nazad",
  cancelled: "Otkazano",
  ok: "U redu",
  forgotPassword: "Zaboravljena lozinka",
  email: "Imejl",
  passwordResetLinkSent: "Ako nalog postoji, poslat je link za resetovanje lozinke.",
  passwordResetRequestFailed: "Zahtev za resetovanje lozinke nije uspeo.",
  sendResetLink: "Pošalji link za resetovanje",
  addFriend: "Dodaj prijatelja",
  incomingRequests: "Dolazni zahtevi",
  accept: "Prihvati",
  deny: "Odbij",
  myFriends: "Moji prijatelji",
  noFriendsYet: "Još nemate prijatelje. Počnite da ih dodajete!",
  seeProfile: "Pogledaj profil",
  noEventsToRespondTo: "Nema događaja za odgovor",
  allCaughtUp: "Sve je pregledano. Proverite kasnije nove događaje svojih prijatelja.",
  events: "Događaji",
  unknown: "Nepoznato",
  noDescriptionProvided: "Opis nije dostavljen.",
  will: "Da",
  maybe: "Možda",
  wont: "Ne",
  userNotFound: "Korisnik nije pronađen",
  friendRequestSentSuccessfully: "Zahtev za prijateljstvo je uspešno poslat!",
  friendInvitation: "Pozivnica za prijateljstvo",
  sendFriendRequest: "Pošalji zahtev za prijateljstvo",
  loginToSendFriendRequest: "Prijavite se da biste poslali zahtev za prijateljstvo",
  chooseLanguage: "Izaberite jezik",
  invalidCredentials: "Neispravni podaci za prijavu. Pokušajte ponovo.",
  username: "Korisničko ime",
  password: "Lozinka",
  forgotPasswordQuestion: "Zaboravili ste lozinku?",
  dontHaveAccount: "Nemate nalog?",
  registerHere: "Registrujte se ovde",
  invalidProfilePhotoType: "Neispravan tip datoteke. Otpremite JPEG, PNG, GIF ili WebP sliku.",
  invalidFileExtension: "Neispravna ekstenzija datoteke",
  allowedExtensions: "Dozvoljeno",
  fileTooLarge: "Datoteka je prevelika",
  maximumFileSize: "Maksimum",
  profilePhotoRemoved: "Profilna fotografija je uklonjena.",
  failedToRemoveProfilePhoto: "Uklanjanje profilne fotografije nije uspelo",
  profileUpdatedSuccessfully: "Profil je uspešno ažuriran!",
  failedToUpdateProfile: "Ažuriranje profila nije uspelo",
  privateEmailExplanation: "Samo vi možete videti svoju imejl adresu kako biste izbegli neželjene poruke van platforme",
  yourEmailIsPrivate: "Vaša imejl adresa je privatna.",
  profilePhoto: "Profilna fotografija",
  removePhoto: "Ukloni fotografiju",
  firstName: "Ime",
  lastName: "Prezime",
  tellPeopleAboutYourself: "Recite nešto o sebi",
  whereToContactMe: "Kako me kontaktirati",
  contactInfoPlaceholder: "Instagram: myUsername\nDiscord: myDiscord",
  save: "Sačuvaj",
  notSet: "Nije podešeno",
  editProfile: "Uredi profil",
  imageToCrop: "Slika za isecanje",
  zoom: "Zumiranje",
  usePhoto: "Koristi fotografiju",
  name: "Ime",
  whereToContact: "Kontakt",
  removeFriendship: "Ukloni prijateljstvo",
  confirmRemoveFriend: "Potvrdi uklanjanje prijatelja",
  confirmRemoveFriendBefore: "Da li ste sigurni da želite da uklonite",
  confirmRemoveFriendAfter: "sa liste prijatelja?",
  friendRemoved: "Prijatelj je uklonjen.",
  failedToRemoveFriend: "Uklanjanje prijatelja nije uspelo.",
  confirmRemove: "Potvrdi uklanjanje",
  error: "Greška",
  removed: "Uklonjeno",
  passwordsDoNotMatch: "Lozinke se ne poklapaju",
  registrationFailed: "Registracija nije uspela. Pokušajte ponovo.",
  confirmPassword: "Potvrdi lozinku",
  alreadyHaveAccount: "Već imate nalog?",
  loginHere: "Prijavite se ovde",
  passwordResetSuccessfully: "Lozinka je uspešno resetovana.",
  failedToResetPassword: "Resetovanje lozinke nije uspelo.",
  resetPassword: "Resetuj lozinku",
  newPassword: "Nova lozinka",
  confirmNewPassword: "Potvrdi novu lozinku",
  setNewPassword: "Postavi novu lozinku",
  emailVerifiedSuccessfully: "Imejl adresa je uspešno verifikovana!",
  emailVerificationFailed: "Verifikacija nije uspela. Link je možda nevažeći ili istekao.",
  verifying: "Verifikacija...",
  verified: "Verifikovano!",
  redirectingToHome: "Preusmeravanje na početnu stranicu...",
  verificationFailed: "Verifikacija nije uspela",
  goToHome: "Idi na početnu stranicu",
  about: "О апликацији",
  aboutConceptTitle: "Концепт",
  aboutCreatorIntroduction: "Здраво, ја сам Crypt0, пењач и творац Run Into Me.",
  aboutCreatorStory: "Направио сам сајт јер сам дружељубив и трошио сам превише времена на организовање пењања са другима.",
  aboutPlanningProblem: "Желео сам да свима истовремено јавим када и где ћу се пењати, без званичног позива.",
  aboutDeveloperSolution: "Тада сам се сетио да сам програмер и да могу сам да направим решење.",
  aboutWelcome: "Добро дошли у Run Into Me, где пријатељима јављате за активности којима могу да се придруже без притиска.",
  aboutCallToAction: "Овде објавите следећу активност која је забавнија у друштву!",
  aboutTutorialTitle: "Упутство",
  aboutCalendarCreateEvent: "На екрану календара можете и да направите нови догађај.",
  aboutEventColorsIntroduction: "Боје показују статус учешћа:",
  aboutColorGold: "Златна",
  aboutColorGoldDescription: "Ви организујете догађај.",
  aboutColorGreen: "Зелена",
  aboutColorGreenDescription: "Учествујете у догађају.",
  aboutColorOrange: "Наранџаста",
  aboutColorOrangeDescription: "Одговорили сте „можда“.",
  aboutColorBlue: "Плава",
  aboutColorBlueDescription: "Још нисте одговорили.",
  aboutColorGray: "Сива",
  aboutColorGrayDescription: "Одбили сте позив.",
  aboutCalendarEventDetails: "Кликните догађај за детаље и одговор.",
  aboutFriendPageTitle: "Страница пријатеља",
  aboutFriendPageDescription: "Унесите корисничко име или пошаљите везу / QR код.",
  aboutHomePageTitle: "Почетна страница",
  aboutHomePageDescription: "Прегледајте догађаје и наведите да ли долазите.",
  aboutRepostScreenTitle: "Екран за поновну објаву",
  aboutGoogleCalendarDescription: "Додајте догађај у Google календар овим дугметом.",
  aboutRepostDescription: "После потврде можете поново објавити догађај пријатељима.",
};

export default sr;
